import { z } from "zod";

export const agentProjectRunStatusSchema = z.enum(["queued", "processing", "complete", "failed"]);

export type AgentProjectRunStatus = z.infer<typeof agentProjectRunStatusSchema>;

export const agentProjectRunSchema = z.object({
  createdAt: z.string(),
  error: z.string().nullish(),
  errorCode: z.string().nullish(),
  mode: z.string().nullish(),
  operationId: z.string(),
  optimisticProjectId: z.string(),
  orgId: z.string().nullish(),
  projectId: z.string().nullish(),
  prompt: z.string().nullish(),
  seedAssetIds: z.array(z.string()).optional().default([]),
  status: agentProjectRunStatusSchema,
  updatedAt: z.string(),
  userId: z.string().nullish(),
  videoAssetId: z.string().nullish(),
  videoUrl: z.string().nullish(),
  workflowId: z.string().nullish(),
  workflowRunId: z.string().nullish(),
});

export type AgentProjectRun = z.infer<typeof agentProjectRunSchema>;

export const agentProjectRunsListResponseSchema = z.object({
  results: z.object({
    page: z.array(agentProjectRunSchema),
    pageInfo: z.object({
      endCursor: z.string().nullish(),
      hasNextPage: z.boolean(),
    }),
  }),
});

export type AgentProjectRunsListResponse = z.infer<typeof agentProjectRunsListResponseSchema>;
